export default "__VITE_ASSET__6f1252dc__"